import { Col } from 'antd'

import { EpidemiologyCaseForm058E_SymptomsSection } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

type Props = {
  symptoms: EpidemiologyCaseForm058E_SymptomsSection
}

export const UrinarySymptomsDetailsCard = ({ symptoms }: Props) => {
  const { t } = useLocales()

  return (
    <>
      <Col span={24}>
        <Text>
          {`7. ${t('epidemiology.urinary_disorders')}`}:{' '}
          <Text weight={400}>
            {t(
              `epidemiology.symptoms.general.${symptoms.urinaryDisorders?.status}`
            )}
          </Text>
        </Text>
      </Col>

      {symptoms.urinaryDisorders?.status === 'yes' && (
        <>
          {symptoms.urinaryDisorders.oliguriaAnuria?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.urinaryDisorders.oliguriaAnuria')}
              </Text>
            </Col>
          )}

          {symptoms.urinaryDisorders.hyperchromicUrine?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.urinaryDisorders.hyperchromicUrine')}
              </Text>
            </Col>
          )}

          {symptoms.urinaryDisorders.hematuria?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.urinaryDisorders.hematuria')}
              </Text>
            </Col>
          )}

          {symptoms.urinaryDisorders.cloudyUrine?.isSelected && (
            <Col span={8}>
              <Text>
                {t('epidemiology.symptoms.urinaryDisorders.cloudyUrine')}
              </Text>
            </Col>
          )}

          {symptoms.urinaryDisorders.frequentMicturition?.isSelected && (
            <Col span={8}>
              <Text>
                {t(
                  'epidemiology.symptoms.urinaryDisorders.frequentMicturition'
                )}
              </Text>
            </Col>
          )}
        </>
      )}
    </>
  )
}
